import CompLayout from "@/pcomponents/comp/layout/layout";
import CoreListArea from "@/pages/comp/plan/video/acommon/corse/list";

function ListPage(){
  return (
    <CompLayout>
      <CoreListArea></CoreListArea>
    </CompLayout>
  );
}

export default ListPage;